import { BLOCK_FORMATS } from '../interface/custom-types'

export const nodesWithEditableContent = [
  BLOCK_FORMATS.table,
  BLOCK_FORMATS.action,
  BLOCK_FORMATS.expandBlock,
]

export const needEmptyLineBeforeTypes = [
  BLOCK_FORMATS.figure,
  BLOCK_FORMATS.video,
  ...nodesWithEditableContent,
]
